import { apiSlice } from './apiSlice';

export const mapNodesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Query to get all map nodes with filters
    getAllMapNodes: builder.query({
      query: ({ hideContacted = false, sortBy = 'contacts' } = {}) => ({
        url: '/mapnodes/all',
        params: { hideContacted, sortBy },
      }),
      providesTags: ['MapNodes'],
    }),
    
    // Mutation to add a new node to the map
    addMapNode: builder.mutation({
      query: (nodeData) => ({
        url: '/mapnodes/add',
        method: 'POST',
        body: nodeData,
      }),
      invalidatesTags: ['MapNodes', 'UserNodes'],
    }),
    
    // Mutation to update an existing node
    updateMapNode: builder.mutation({
      query: ({ nodeId, ...nodeData }) => ({
        url: `/mapnodes/${nodeId}`,
        method: 'PUT',
        body: nodeData,
      }),
      invalidatesTags: ['MapNodes'],
    }),
    
    // Mutation to record a contact with a node
    contactNode: builder.mutation({
      query: (nodeId) => ({
        url: `/mapnodes/${nodeId}/contact`,
        method: 'POST',
      }),
      invalidatesTags: ['MapNodes', 'UserNodes'],
      // Optimistic update for better UX
      async onQueryStarted(nodeId, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          mapNodesApi.util.updateQueryData('getAllMapNodes', undefined, (draft) => {
            const node = draft.find((n) => n.nodeId === nodeId);
            if (node) {
              node.contactCount += 1;
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    
    // Mutation to remove a contact (undo)
    uncontactNode: builder.mutation({
      query: (nodeId) => ({
        url: `/mapnodes/${nodeId}/contact`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MapNodes', 'UserNodes'],
      // Optimistic update for better UX
      async onQueryStarted(nodeId, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          mapNodesApi.util.updateQueryData('getAllMapNodes', undefined, (draft) => {
            const node = draft.find((n) => n.nodeId === nodeId);
            if (node && node.contactCount > 0) {
              node.contactCount -= 1;
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    
    // Mutation to delete a node
    deleteMapNode: builder.mutation({
      query: (nodeId) => ({
        url: `/mapnodes/${nodeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MapNodes'],
    }),
  }),
});

export const {
  useGetAllMapNodesQuery,
  useAddMapNodeMutation,
  useUpdateMapNodeMutation,
  useContactNodeMutation,
  useUncontactNodeMutation,
  useDeleteMapNodeMutation,
} = mapNodesApi;

